import { useEffect, useRef, useState } from 'react'
import { API } from 'src/utils/interceptor'

/**
 * Recipes whose GP moved since this person last opened Menu Builder.
 * The clock starts once the list has loaded, including when nothing moved.
 */
const useMenuBuilderSinceLook = (venueId, enabled) => {
  const [banner, setBanner] = useState(null)
  const captured = useRef(false)

  useEffect(() => {
    if (!venueId || !enabled) return undefined
    let cancelled = false

    const run = async () => {
      try {
        const result = await API.get(
          'api2',
          `recipes/venue/${venueId}/changes-since-look`,
        )
        if (cancelled) return
        if (result?.show && result?.body) {
          captured.current = true
          setBanner(result)
        } else if (!captured.current) {
          setBanner(null)
        }
        await API.post(
          'api2',
          `recipes/venue/${venueId}/changes-since-look/seen`,
          { body: {} },
        )
      } catch (error) {
        return error
      }
    }

    run()
    return () => {
      cancelled = true
    }
  }, [venueId, enabled])

  return banner
}

export default useMenuBuilderSinceLook
